import { render, staticRenderFns } from "./imgT.vue?vue&type=template&id=d24aa496"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24aa496')) {
      api.createRecord('d24aa496', component.options)
    } else {
      api.reload('d24aa496', component.options)
    }
    module.hot.accept("./imgT.vue?vue&type=template&id=d24aa496", function () {
      api.rerender('d24aa496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgT.vue"
export default component.exports